"use strict";

import $ from "jquery";

// Turbolinks 👍🏻🖕🏻🙄
$(document).on("ready", function () {
  if (window && window.location) {
    if (require("url").parse(window.location.toString()).port == 3001) {
      $("body").attr("data-turbolinks", "false");
    }
  }
});
